import {
    buildHeadline,
    buildSecondaryLine,
    mergeAppointmentPayload,
    type AppointmentPayload,
    type SchedulerAppointmentTemplateData,
} from '@/components/agenda/agenda-appointment-display';
import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';
import { useTranslate } from 'react-admin';

/**
 * Vista agenda: marcador de color + título (cliente|sitio|lugar) + línea secundaria (postal/ciudad · tipo).
 * Props: `devextreme-react/scheduler` → `appointmentComponent`.
 */

const detailLineStyle: CSSProperties = {
    fontSize: 12,
    lineHeight: 1.35,
    opacity: 0.72,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
};

/** El tema pone `white-space: nowrap` + `overflow: hidden` en `.dx-scheduler-appointment-title`; en flex puede recortar mal la 1ª línea. */
const titleStyle: CSSProperties = {
    margin: 0,
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'clip',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 1.25,
    color: 'rgba(0, 0, 0, 0.87)',
};

export default function AgendaItemCustom(props: { data?: SchedulerAppointmentTemplateData }) {
    const translate = useTranslate();
    const appointmentData = mergeAppointmentPayload(props.data);
    if (!appointmentData) {
        return null;
    }

    const isRecurrence = Boolean((appointmentData as AppointmentPayload).recurrenceRule);
    const markerColor = appointmentData.color ?? '#337ab7';
    const headline = buildHeadline(appointmentData);
    const secondaryLine = buildSecondaryLine(appointmentData, translate);

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: 0.5,
                alignItems: 'center',
                alignContent: 'center',
                height: '100%',
            }}
        >
            <div className='dx-scheduler-agenda-appointment-left-layout'>
                <div className='dx-scheduler-agenda-appointment-marker' style={{ backgroundColor: markerColor }}>
                    {isRecurrence ? <span className='dx-scheduler-appointment-recurrence-icon dx-icon-repeat' /> : null}
                </div>
            </div>

            <Box
                className='dx-scheduler-agenda-appointment-right-layout'
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                    flex: 1,
                    justifyContent: 'center',
                }}
            >
                <div className='dx-scheduler-appointment-title' style={titleStyle}>
                    {headline}
                </div>

                {secondaryLine ? (
                    <div style={{ ...detailLineStyle, opacity: 0.88, fontSize: 14 }}>{secondaryLine}</div>
                ) : null}
            </Box>
        </Box>
    );
}
